import { render } from "./OffersView.vue?vue&type=template&id=348edf32&scoped=true&ts=true"
import script from "./OffersView.vue?vue&type=script&lang=ts"
export * from "./OffersView.vue?vue&type=script&lang=ts"

import "./OffersView.vue?vue&type=style&index=0&id=348edf32&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348edf32"]])

export default __exports__